import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

interface Props {
  items: Crumb[];
}

export default function Breadcrumbs({ items }: Props) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex flex-wrap items-center gap-1.5 text-sm text-foreground-500">
        {items.map((item, i) => {
          const last = i === items.length - 1;
          return (
            <li key={`${item.label}-${i}`} className="flex items-center gap-1.5">
              {item.to && !last ? (
                <Link to={item.to} className="transition-colors hover:text-primary-700">
                  {item.label}
                </Link>
              ) : (
                <span className={last ? 'font-medium text-foreground-800' : ''} aria-current={last ? 'page' : undefined}>
                  {item.label}
                </span>
              )}
              {!last && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}